import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { StepFunctions } from "../joyrideSteps";
import { changeStepStorage } from "../joyrideCallbackHandler";
import StartStep from "./StartStep";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ServiceProvidersStep: React.FC<StepFunctions> = ({ goToStep, booleanValue }) => {
    const { t } = useTranslation();
    const [showStartStep, setShowStartStep] = useState(false);
    const handleButtonClick = () => setShowStartStep(true);
    const handleMove = () => {
        goToStep("next");
    };

    return (
        <>
            {showStartStep ? (
                <StartStep setShowStartStep={setShowStartStep} />
            ) : (
                <>
                    <Row>
                        <Col xs={11}>
                            <p className="fs-7">
                                <span className="fs-normal fw-bold fs-7">{t("Select an employee")}</span>{" "}
                                {t("as a service provider")}
                            </p>
                        </Col>
                        <Col xs={1} className="p-0 text-center">
                            <Button variant="link" className="p-0" onClick={handleButtonClick}>
                                <i className="bi bi-x-lg "></i>
                            </Button>
                        </Col>
                    </Row>
                    <Row className="m-0 pt-3  border-top">
                        <Col className="text-end p-0">
                            <Button
                                variant={booleanValue ? "primary" : "secondary"}
                                className="px-4"
                                onClick={handleMove}
                                disabled={!booleanValue}
                            >
                                {t("Next")}
                            </Button>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

export default ServiceProvidersStep;
